/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { TenantService } from '@src/app/shared/tenant.service';
import { UnreadChart } from "@src/app/modules/agent/agent-dashboard-page/UnreadChart";
import { ActionPageNavRoute } from '@src/app/routes/action-page-nav';

export class UnreadActionsChart extends UnreadChart {
    dataUrl = TenantService.ajaxPath + 'agent/dashboard/unreadActions';
    title = "My Unread Actions";

    getSubTitle() {
        return super.getSubTitle($localize`Actions assigned to me I have not read yet`);
    }

    clickEvent() {
        const url = ActionPageNavRoute.getListRouteName();
        const params = { ownedById: this.dataUserId, ownerReadAt: 'NULL' };

        this.router.navigate([url, params]);
    }
}
